import { NavigationItem } from '@cinesend/ui-kit'
import { CaretLeft } from '@phosphor-icons/react'
import { useNavigate } from 'react-router-dom'

const SettingsBackButton = () => {
  const navigate = useNavigate()

  const goBack = () => {
    let pathname = localStorage.getItem('backToMetadata')
    localStorage.removeItem('backToMetadata')

    if (!pathname) pathname = '/dashboard'
    navigate(pathname)
  }

  return (
    <NavigationItem icon={<CaretLeft size={20} weight='regular' aria-hidden='true' />} onClick={goBack}>
      Settings
    </NavigationItem>
  )
}

export default SettingsBackButton
